export default {
    ruleTemplateData: []
}
